import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import Price from '../../../../components/stateless/Price';
import Translation from '../../../../components/stateless/Translation';

const SMFacilitiesListItemUnit = ({ facility:
  { cheapestUnitSummary, currency, currencyLocale, settings: { useWeeklyRates } } }) => {
  if (!cheapestUnitSummary) {
    return null;
  }

  const priceRate = useWeeklyRates
    ? cheapestUnitSummary.minPriceWeekly : cheapestUnitSummary.minPrice;
  return (
    <div className="mt-0 w-24 flex flex-col mb-2 leading-tight min-[350px]:text-right">
      <Translation
        id="widgets.facilityList.ratesAt"
        defaultMessage="Rates From"
      />
      <div className="flex items-baseline font-bold min-[350px]:justify-end">
        <span className="text-leading-tight rtl:text-left text-lg">
          <Price
            currency={currency}
            locale={currencyLocale}
            round
            value={priceRate}
          />
        </span>
        <span className="text-sm top-0">
          <Translation
            id={useWeeklyRates ? 'widgets.abbreviation.wk' : 'widgets.abbreviation.mo'}
            defaultMessage={useWeeklyRates ? '/wk' : '/mo'}
          />
        </span>
      </div>
    </div>
  );
};

SMFacilitiesListItemUnit.propTypes = {
  facility: PropTypes.shape({
    currency: PropTypes.string,
    cheapestUnitSummary: PropTypes.shape({
      minPrice: PropTypes.string.isRequired,
      minPriceWeekly: PropTypes.string.isRequired,
    }),
    settings: PropTypes.shape({
      useWeeklyRates: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};

SMFacilitiesListItemUnit.defaultProps = {};

SMFacilitiesListItemUnit.fragments = {
  facility: gql`
    fragment SMFacilitiesListItemUnitFacility on Facility {
      currencyLocale
      currency
      cheapestUnitSummary {
        minPrice
        minPriceWeekly
      }
      settings {
        useWeeklyRates
      }
    }
  `,
};

export default SMFacilitiesListItemUnit;
